const FIREBASE_VERSION = "12.14.0";
const ACTIVATION_WAIT_TIMEOUT_MS = 1200;
const LOG_PREFIX = "[Firebase Remote Config]";
const GLOBAL_NAME = "ARZZFirebaseRemoteConfig";

const firebaseConfig = {
  apiKey: "AIzaSyAxxTF0e28btRvB7BvF2PK6EZooD5AgXyQ",
  authDomain: "schutz-firebase.firebaseapp.com",
  projectId: "schutz-firebase",
  storageBucket: "schutz-firebase.firebasestorage.app",
  messagingSenderId: "239933706135",
  appId: "1:239933706135:web:e9a75d2cd2f36d92bbbed2",
  measurementId: "G-QN6XSJEQMP",
};

const existingApi = window[GLOBAL_NAME];

if (!existingApi || typeof existingApi.getVariant !== "function") {
  let remoteConfigInstance = null;
  let getRemoteConfigValue = null;
  let activationPromise = Promise.resolve(false);

  const remoteConfigReady = initializeRemoteConfig();

  window[GLOBAL_NAME] = {
    getVariant: async (parameterName, defaultValue = "0") => {
      const fallbackValue = String(defaultValue);

      try {
        if (!parameterName) {
          throw new Error("Parameter name is required.");
        }

        await remoteConfigReady;

        if (!remoteConfigInstance || typeof getRemoteConfigValue !== "function") {
          return fallbackValue;
        }

        remoteConfigInstance.defaultConfig = {
          ...(remoteConfigInstance.defaultConfig || {}),
          [parameterName]: fallbackValue,
        };

        const remoteValue = getRemoteConfigValue(remoteConfigInstance, parameterName).asString();

        return remoteValue === "" ? fallbackValue : remoteValue;
      } catch (error) {
        console.error(`${LOG_PREFIX} Failed to get "${parameterName}".`, error);
        return fallbackValue;
      }
    },
    waitForActivation: async () => {
      await remoteConfigReady;
      await activationPromise;
    },
  };

  async function initializeRemoteConfig() {
    try {
      const appModuleUrl = `https://www.gstatic.com/firebasejs/${FIREBASE_VERSION}/firebase-app.js`;
      const remoteConfigModuleUrl = `https://www.gstatic.com/firebasejs/${FIREBASE_VERSION}/firebase-remote-config.js`;

      const [{ initializeApp, getApp, getApps }, { getRemoteConfig, fetchAndActivate, getValue }] = await Promise.all([
        import(appModuleUrl),
        import(remoteConfigModuleUrl),
      ]);

      const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
      const remoteConfig = getRemoteConfig(app);

      remoteConfig.settings = {
        minimumFetchIntervalMillis: 3600000,
        fetchTimeoutMillis: 60000,
      };

      remoteConfig.defaultConfig = {};

      remoteConfigInstance = remoteConfig;
      getRemoteConfigValue = getValue;

      activationPromise = fetchAndActivate(remoteConfig).catch((error) => {
        console.error(`${LOG_PREFIX} Failed to fetch and activate Remote Config.`, error);
        return false;
      });

      await Promise.race([activationPromise, wait(ACTIVATION_WAIT_TIMEOUT_MS)]);
    } catch (error) {
      console.error(`${LOG_PREFIX} Failed to initialize Remote Config.`, error);
    }
  }

  function wait(timeout) {
    return new Promise((resolve) => {
      window.setTimeout(resolve, timeout);
    });
  }
}
